import React, { useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import CustomViewsHandler from "../CustomViewsHandler/CustomViewsHandler";
import { applyExtraFilters, handleFilterChange, handleParameterChange } from "../../utils/actions/actions";
import { useDashboardFiltersContext } from "../../utils/context/dashboardFilters/dashboardFiltersContextStateConfig";
import gifLoading from "../../assets/gifs/Lightcast_LoadingGif_Sailor_Red.gif";

const loadingMessages = [
    "Applying saved filters...",
    "Updating dashboard parameters...",
    "This may take a few seconds...",
];

const DashboardPublic = (
    {
        width = 1000,
        height = 800,
        hideToolbar = false,
        link,
        sidebar,
        setHideBar,
        stickyFiltersEnabled = false,
        solutionConfigurationEnabled = false,
        userId,
        scope
    }) => {

    const { dashboardFilters, setDashboardFilters } = useDashboardFiltersContext();
    const [ DashboardContentLoading, setDashboardContentLoading ] = useState(false);
    const [ loadingMessageIndex, setLoadingMessageIndex ] = useState(0);
    const dashboardLoaded = useRef(false);

    useEffect(() => {
      if(!DashboardContentLoading){
        setLoadingMessageIndex(0);
        return;
      }

      const loadingMessageInterval = setInterval(() => {
        setLoadingMessageIndex((currentIndex) =>
          (currentIndex + 1) % loadingMessages.length
        );
      }, 4000);

      return () => clearInterval(loadingMessageInterval);
    }, [DashboardContentLoading]);
    
    useEffect(() => {
      if(window.innerWidth > 767){
        if(sidebar === "HIDDEN"){
            setHideBar(sidebar);
        }else if(sidebar === "ALWAYS OPEN"){
            setHideBar(sidebar);
        }else if(sidebar === "CLOSED"){
            setHideBar(true);
        }else{
            setHideBar(null);
        }
      }
    },[sidebar, setHideBar])

    const vizRef = useRef(null); 


    const dashboardFiltersRef = useRef(dashboardFilters);

    useEffect(() => {
      dashboardFiltersRef.current = dashboardFilters;
    }, [dashboardFilters]);

    const loadTableau = async (mantainFilters = true, customView = null) => {
      const baseWidth = parseInt(width);
      const baseHeight = parseInt(height);

      let customizedWidth = baseWidth;
      let customizedHeight = baseHeight;

      if (vizRef.current) {
        vizRef.current.innerHTML = "";
      }

      const vizElement = document.createElement("tableau-viz");
      vizElement.setAttribute("src", link);
      vizElement.setAttribute("height", customizedHeight + 27);
      vizElement.setAttribute("width", customizedWidth);
      vizElement.setAttribute("toolbar", "hidden");
      vizElement.setAttribute("hideTabs", "true");

      if (stickyFiltersEnabled) {

        vizElement.addEventListener("parameterchanged", (event) =>
          handleParameterChange(event, scope, setDashboardFilters, vizRef.current?.querySelector("tableau-viz"))
        );

        vizElement.addEventListener("filterchanged", (event) =>  
          handleFilterChange(event, scope, setDashboardFilters, vizRef.current?.querySelector("tableau-viz"))
        );

        const filtersToApply = customView ?? dashboardFiltersRef.current[scope];
        const shouldApplyFilters = customView || (
          (filtersToApply?.filters.length > 0 || filtersToApply?.parameters.length > 0) &&
          mantainFilters
        );

        if(shouldApplyFilters){
          setDashboardContentLoading(true);
          vizElement.addEventListener("firstinteractive", async () => {
            await applyExtraFilters(
              filtersToApply,
              scope,
              setDashboardFilters,
              vizRef.current?.querySelector("tableau-viz"),
              setDashboardContentLoading
            );
          });
        }
      }

      vizRef.current.appendChild(vizElement);

      dashboardLoaded.current = true;
    };

    useEffect(() => {
      dashboardLoaded.current = false;
    }, [link]);

    useEffect(() => {
      if(!dashboardLoaded.current){
        loadTableau();
      }
    });

    //   const readDashboardFilters = async () => {
    //     try {
    //         const tableauViz = vizRef.current?.querySelector("tableau-viz");
        
    //         if (!tableauViz?.workbook) return;

    //         const workbook = tableauViz.workbook;
    //         const activeSheet = workbook.activeSheet;


    //         if (activeSheet.sheetType === "dashboard") {
    //             const worksheets = activeSheet.worksheets;

    //             const all = (
    //                 await Promise.all(
    //                     worksheets.map(async (ws) => {
    //                     const wsFilters = await ws.getFiltersAsync();
    //                     console.log(wsFilters)

    //                     const filteredFilters = wsFilters.map((f) => (
    //                         {
    //                             name: f.fieldName,
    //                             type: f.filterType,
    //                             appliedValues: f.appliedValues?.map((v) => v.value) ?? [],
    //                         }
    //                     )).filter((f) => f.appliedValues.length > 0);

    //                     if (filteredFilters.length === 0) {
    //                         return null;
    //                     }

    //                     return {
    //                         worksheet: ws.name,
    //                         filters: filteredFilters,
    //                     };
    //                 }))
    //             ).filter(Boolean);

    //             console.log("[Tableau] Dashboard filters:", all);

    //             return;
    //         }

    //         const wsFilters = await activeSheet.getFiltersAsync();
    //         const single = [
    //             {
    //                 worksheet: activeSheet.name,
    //                 filters: wsFilters.map((f) => (
    //                     {
    //                         name: f.fieldName,
    //                         type: f.filterType,
    //                         appliedValues: f.appliedValues?.map((v) => v.value) ?? [],
    //                     }
    //                 )).filter((f) => f.appliedValues.length > 0)
    //             },
    //         ];

    //         console.log("[Tableau] Worksheet filters:", single);
    //     } catch (error) {
    //         console.error("[Tableau] Error reading filters:", error);
    //     }
    // };
      
    
    return (
        <Row className="justify-content-md-center" id="view">
            <Col xs={12} className="mb-4 d-none d-sm-block d-flex">
            {/* <button className="read-filters-btn" onClick={readDashboardFilters}>Read current filters</button> */}
                {
                    solutionConfigurationEnabled && scope &&
                    <CustomViewsHandler 
                        currentFilters={dashboardFilters[scope] ?? []} 
                        setFilters={setDashboardFilters}
                        loadingApplyFilters={setDashboardContentLoading}
                        reloadView={loadTableau}
                        userId={userId} 
                        scope={scope}
                        publicRef={vizRef}
                    />
                }
                <section
                    className="tableau-cloud-stage"
                    style={{
                        minWidth: `${width}px`,
                        width: `${width}px`,
                        minHeight: `${hideToolbar ? height : height + 27}px`,
                        height: `${hideToolbar ? height : height + 27}px`,
                    }}
                >
                    <div className="tableauPublic" ref={vizRef} />
                    {
                        DashboardContentLoading &&
                        <div
                            className="dashboard-content-loading"
                            role="status"
                            aria-label="Loading dashboard content"
                        >
                            <img
                                className="loading-screen__gif"
                                src={gifLoading}
                                alt=""
                            />
                            <p className="dashboard-content-loading__message pt-4">
                                {loadingMessages[loadingMessageIndex]}
                            </p>
                        </div>
                    }
                </section>
                <div className="footer-gradient"></div>
            </Col>
        </Row>
    )
}

export default DashboardPublic;
